"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib"); // import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';


var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var templateObject_1;